export type SchoolStudentGroup = {
  "@context": string;
  "@id": string;
  "@type": string;
  id: number;
  name: string;
};

export type SchoolStudentGroupInput = {
  name: string;
};
